import Head from 'next/head';

import type { FC } from 'react';

export interface BuilderPixelProps {
  properties: { src: string };
}

const BuilderPixel: FC<BuilderPixelProps> = ({ properties }) => (
  <Head>
    <link key="builder-pixel" rel="preload" as="image" href={properties?.src} />
  </Head>
);

export default BuilderPixel;
